import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import styled from "styled-components";
import Column from "../Column";
import { transformToTasks } from "../../../../../helpers";
import WorkService from "../../../../services/WorkService";

const Cards = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default function (props) {
  const { filters, setFilters, refreshWorks } = props;

  const assigneToCourier = async (selectedWork, courier_id) => {
    try {
      const response = await WorkService.assignToCourier(selectedWork, {
        courier_id: courier_id,
      });
      if (response.status === 200) {
        NotificationManager.success(
          "Travail affecté au coursier",
          "Notification"
        );
      }
    } catch (err) {
      NotificationManager.error(err?.response?.data?.message, "Notification");
    }
  };

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    const workID = parseInt(draggableId.match(/\d+/)[0], 10);
    if (!destination) return;
    if (
      destination.droppableId === source.droppableId ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index)
    ) {
      return;
    }
    const coursierID = parseInt(destination.droppableId.match(/\d+/)[0]);
    //console.log("result", result);
    // console.log(
    //   "result",
    //   workID,
    //   result,
    //   destination.index,
    //   filters.coursiers,
    //   filters.coursiers[destination.index]
    // );
    //console.log(destination, coursierID);
    // console.log(
    //   destination.index,
    //   filters.coursiers,
    //   workID,
    //   filters.coursiers[destination.index].id
    // );
    //refreshWorks();
    assigneToCourier(workID, coursierID);
  };

  const [data, setData] = useState({
    tasks: filters.tasks,
    columns: {
      "column-1": {
        id: "column-1",
        title: "Travaux non affectes",
        tasksIds: filters.entredTasks,
      },
    },
  });

  const createAgentsColumn = () => {
    let columns = [];
    filters.coursiers.map((coursier, id) => {
      console.log("id here", id);
      columns["coursier-" + coursier.id] = {
        id: "coursier-" + coursier.id,
        title: coursier.first_name,
        tasksIds: [],
      };
    });
  };

  useEffect(() => {
    console.log("coursiers", filters.coursiers, filters);
    createAgentsColumn();
    setData({
      tasks: filters.tasks,
      columns: {
        "column-1": {
          id: "column-1",
          title: "Travaux non affectes",
          tasksIds: filters.entredTasks,
        },
      },
    });
  }, [filters]);

  const getTasks = (id) => {
    let ltasks = filters.allWorks.filter((w) => w.courier_id == id);

    if (filters.travaux == 1) {
      ltasks = [...ltasks].filter(
        (w) => w.status === "outgoing_dentist" 
      );
    } else if (filters.travaux == 2) {
      ltasks = [...ltasks].filter(
        (w) => w.status === "outgoing_laboratory" 
      );
    }

    if (filters.dentists.length > 0) {
      ltasks = [...ltasks].filter((w) =>
        filters.dentists.includes(w.dentist_id)
      );
    }
    if (filters.service) {
      ltasks = [...ltasks].filter((w) => w.service_id == filters.service);
    } else if (filters.groupe) {
      ltasks = [...ltasks].filter(
        (w) => w.service.sub_group_id == filters.groupe
      );
    }

    let transformedTasks = transformToTasks(ltasks, []);
    console.log([transformedTasks[1], transformedTasks[0]]);
    return [transformedTasks[1], transformedTasks[0]];
  };

  return (
    <Cards>
      <NotificationContainer />
      <DragDropContext onDragEnd={onDragEnd}>
        {filters.entredTasks && (
          <Column
            key={data.columns["column-1"].id}
            column={data.columns["column-1"]}
            tasks={data.columns["column-1"].tasksIds.map(
              (taskId) => data.tasks[taskId]
            )}
          />
        )}

        {filters.coursiers.map((coursier) => (
          <Column
            filters={filters}
            key={coursier.id}
            id={coursier.id}
            column={{
              id: "Courier-" + coursier.id,
              title: coursier.first_name,
              tasksIds: getTasks(coursier.id)[1],
            }}
            tasks={getTasks(coursier.id)[1].map(
              (taskId) => getTasks(coursier.id)[0][taskId]
            )}
          />
        ))}
      </DragDropContext>
    </Cards>
  );
}
